module.exports = __webpack_public_path__ + "img/tn-timeline-main-12.80e46663.jpg";